import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faSave,
  faCheck,
  faXmark,
  faFileLines,
  faCloudArrowUp,
  faEye,
  faArrowUpRightFromSquare
} from "@fortawesome/free-solid-svg-icons";
import Modal from "@/components/Modal"; // Adjust the path as needed
import { useNavigate } from "react-router-dom";

const Table = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields,
  handleLog,
  hideChangeLog,
  blackListTypeList,
  editable
}) => {
  const [summaryModalOpen, setSummaryModalOpen] = useState(false);
  const [summaryData, setSummaryData] = useState([]);
  const [summaryTitle, setSummaryTitle] = useState("");
  const navigate = useNavigate();

  const handleSummaryClick = (data, title) => {
    setSummaryData(data || []);
    setSummaryTitle(title || "Summary");
    setSummaryModalOpen(true);
  };

  return (
    <div className="tableContainer max-w-full w-[90vw]">
      <table className="table text-xs w-[88vw]" role="table">
        <thead className="stickyHeader bg-[var(--mainCol)] text-white">
          <tr>
            {headers?.map((header, index) => (
              <th className="p-1 text-left border" key={index}>
                {header.toUpperCase()}
              </th>
            ))}
            {editable && 
              <th
              style={{ background: "var(--mainCol)" }}
              className="p-1 text-left border stickyActionColumn z-1"
            >
              ACTION
            </th>
            }
          
          </tr>
        </thead>
        <tbody>
          {rows?.map((row) => (
            <tr key={row.id}>
              {headers.map((header) => (
                <td key={header} className="p-3 border">
                  {editRowId === row.id && editableFields?.includes(header) ? (
                    // BOOLEAN FIELD HANDLING
                    header === "active" ||
                    header === "status" ||
                    header === "is_blackList" ||
                    header === "is_read" ||
                    header === "is_Finshed" ||
                    header === "is_Start" ||
                    header === "queryResolve" ? (
                      <div className="cursor-pointer flex justify-center">
                        {editedData[header] === true && (
                          <FontAwesomeIcon
                            onClick={(e) => handleChange(e, header, true)}
                            color="var(--green_Main)"
                            icon={faCheck}
                          />
                        )}
                        {editedData[header] === false && (
                          <FontAwesomeIcon
                            onClick={(e) => handleChange(e, header, false)}
                            color="indianred"
                            icon={faXmark}
                          />
                        )}
                      </div>
                    ) : // DROPDOWN FOR blackListType
                    header === "blackListType" ? (
                      <select
                        className="w-full p-1 border"
                        value={editedData[header] || ""}
                        onChange={(e) =>
                          handleChange(e, header, e.target.value)
                        }
                      >
                        <option value="" hidden>
                          Select Type
                        </option>
                        {blackListTypeList?.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                    ) : (
                      // DEFAULT TEXT INPUT
                      <input
                        type="text"
                        value={editedData[header] || ""}
                        onChange={(e) => handleChange(e, header)}
                        onKeyUp={(e) => e.key === "Enter" && handleSave()}
                        className="w-full p-1 border"
                      />
                    )
                  ) : // NON-EDIT MODE VIEW
                  header === "blackListSummry" && Array.isArray(row[header]) ? (
                    <button
                      className="text-blue-500 underline text-xs outline-none text-nowrap"
                      onClick={() =>
                        handleSummaryClick(row[header], "Blacklist Summary")
                      }
                    >
                      View Summary{" "}
                      <FontAwesomeIcon
                        color="black"
                        className="ml-2"
                        icon={faEye}
                      />
                    </button>
                  ) : row[header] === true ? (
                    <FontAwesomeIcon
                      className="ml-2"
                      color="var(--green_Main)"
                      icon={faCheck}
                    />
                  ) : row[header] === false ? (
                    <FontAwesomeIcon
                      className="ml-2"
                      color="indianred"
                      icon={faXmark}
                    />
                  ) : header === "BackgroundImage" && row[header] ? (
                    <>
                      <img
                        src={row[header]}
                        alt="background"
                        className="max-h-16 max-w-[120px] object-contain"
                      />
                      <label
                        htmlFor="fileUpload"
                        className="text-center text-nowrap mt-10 cursor-pointer"
                      >
                        <FontAwesomeIcon icon={faCloudArrowUp} /> Upload new
                        Image
                      </label>
                      {/* Optional file input */}
                      {/* <input
                          id="fileUpload"
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleUploadImage(row, e.target.files[0])}
                          className="mb-3 hidden"
                        /> */}
                    </>
                  ) : header === "UserId" ? (
                    <button
                      className="text-xs text-blue-600 text-nowrap"
                      onClick={() =>
                        navigate(`/panel-user/${row[header]}`)
                      }
                    >
                     {String(row[header])}  <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                    </button>
                  ) : (
                    String(row[header])
                  )}
                </td>
              ))}
              {editable && 
                <td className="p-2 border stickyActionColumn">
                {editRowId === row.id ? (
                  <div className="flex justify-center">
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="#67a97b"
                      onClick={handleSave}
                      icon={faSave}
                    />
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="indianred"
                      onClick={handleCancel}
                      icon={faXmark}
                    />
                  </div>
                ) : (
                  <div className="flex justify-center z-100">
                    <FontAwesomeIcon
                      className="cursor-pointer"
                      onClick={() => handleEdit(row.id)}
                      icon={faPenToSquare}
                    />
                    {!hideChangeLog && (
                      <FontAwesomeIcon
                        className="ml-2 cursor-pointer"
                        onClick={() => handleLog(row.id)}
                        icon={faFileLines}
                      />
                    )}
                  </div>
                )}
              </td>
              }
            
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal for Summary */}
      {summaryModalOpen && (
        <Modal
          isOpen={summaryModalOpen}
          onClose={() => setSummaryModalOpen(false)}
          title={summaryTitle}
          content={
            <table className="w-full border text-xs">
              <thead>
                <tr>
                  {summaryData.length > 0 &&
                    Object.keys(summaryData[0]).map((key, idx) => (
                      <th key={idx} className="p-1 border text-left">
                        {key.toUpperCase()}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {summaryData.map((item, idx) => (
                  <tr key={idx}>
                    {Object.values(item).map((val, i) => (
                      <td key={i} className="p-1 border">
                        {String(val)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          }
        />
      )}
    </div>
  );
};

export default Table;
